import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

interface BannerProps {
  adSpaceBanner: any[];
}

const BannerSection: React.FC<BannerProps> = ({ adSpaceBanner }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (adSpaceBanner.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % adSpaceBanner.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [adSpaceBanner]);

  return (
    <Box
      sx={{
        // ❌ Removed fixed height: 220, to make it responsive
        position: "relative",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        overflow: "hidden",
        borderRadius: 1,

        // ✅ ADDED: Aspect Ratio using padding-top for responsiveness.
        // The height is calculated as a percentage of the width.
        // Taller banner on mobile (e.g., 4:1 ratio), wider on desktop (e.g., 5:1 ratio).
        paddingTop: {
          xs: '40%', // Height is 40% of the width on small screens (e.g., mobile)
          sm: '30%', // Height is 30% of the width on medium screens (e.g., tablet)
          md: '20%', // Height is 20% of the width on large screens (e.g., desktop)
        },
        height: 0, // CRITICAL: Sets the intrinsic height to zero so padding controls size
      }}
    >
      {adSpaceBanner.length > 0 ? (
        // The content (image) must be positioned absolutely to fill the space
        <a
          href={adSpaceBanner[currentIndex].adSpaceThumbnailUrl || "#"}
          target="_blank"
          rel="noopener noreferrer"
          style={{ 
            width: "100%", 
            height: "100%", 
            position: "absolute", // CRITICAL: Absolute position to fill the padded parent
            top: 0,
            left: 0,
          }}
        >
          <Box
            component="img"
            src={adSpaceBanner[currentIndex].adSpaceImageUrl}
            alt={adSpaceBanner[currentIndex].name || "Home Banner"}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "opacity 0.8s ease-in-out",
            }}
          />
        </a>
      ) : (
        // Fallback Box also needs absolute positioning to fill the new container height
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            maxWidth: 1220,
            width: "100%",
            color: "#fff",
            background: `linear-gradient(to right, #1e293b, rgba(0, 19, 144, 0.85))`,
            height: "100%", // This now refers to the parent's absolute height
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography 
            variant="h4" 
            fontWeight="bold" 
            gutterBottom
            sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' } // Responsive font size
            }}
          >
            Find the Right Car for You
          </Typography>
          <Typography 
            variant="subtitle1"
            sx={{ 
                fontSize: { xs: '0.875rem', sm: '1rem' } // Responsive font size
            }}
          >
            Explore a wide range of vehicles, from SUVs to affordable rides.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default BannerSection;